import { Injectable } from '@angular/core'
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Subject } from 'rxjs/Subject';
import { Http } from '@angular/http'
import { Router } from '@angular/router'
import { AutentificacionService } from '../_services/autentificacion.service'
import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

@Injectable()

export class SeguridadService {

    private dejoPasarUsuario: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public dejoPasarUsuarioEmitter: Observable<boolean> = this.dejoPasarUsuario.asObservable();

    constructor(
        private http: Http,
        private router:Router,
        private autentificacion:AutentificacionService,
        private globalEventsManager: GlobalEventsManager,
      ) {

      //this.getLogado();

    }

    getLogado(){

      //console.log("entro getLogado Seguridad");

      let userToken : string = localStorage.getItem('currentUserToken');


      if (userToken == "" || !userToken){
        console.log("No hay token");
        this.dejoPasarUsuario.next(false);
      }else{
        //si llega token comprobamos que aún está la sesión activa
        this.autentificacion.isLoginActive(userToken).subscribe(
                    data => {

                        let user = data;
                        let error = user.error; //almacenamos el parámetro error
                        let numerrores = Object.keys(error).length; // miramos si llega vacío

                        if (numerrores == 0){
                          this.dejoPasarUsuario.next(true);
                          console.log("Sesion activa");
                        }else{
                          console.log(user.error.errormsg);
                          this.autentificacion.logout();
                          this.dejoPasarUsuario.next(false);
                        }

                    },
                    error => {
                        //console.log("error login");
                    });

      }

    }

    getError(response: any): Boolean{

      var salida: Boolean = false;

      let json = response.json(); //recogemos el json del response
      let error = json.error; //almacenamos el parámetro error

      let numerrores = Object.keys(error).length; // miramos si llega vacío

      //console.log("num errores "+numerrores);

      if (numerrores != 0) {
        //tengo error, hay que actuar
        salida = true;

        let errorcode = json.errorcode;

        if (errorcode == "DNUSER003" || errorcode == "DNUSER004"  || errorcode == "DNUSER005" || errorcode == "DNUSER006"){

          console.log(errorcode);
          this.autentificacion.logout();
          this.dejoPasarUsuario.next(false);

        }else{

          this.globalEventsManager.objError(error);
          if (error.errorcode != undefined && error.errorcode != "DNUSER006"){
            this.globalEventsManager.mostrarError(true);
          }

        }

      }

      return salida;

    }

}



// WEBPACK FOOTER //
// ./src/app/_services/seguridad.service.ts